import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function Bonuses() {
  return <section className="py-20 bg-stone-900 text-stone-50" data-id="element-25">
      <div className="container mx-auto px-4 md:px-6" data-id="element-26">
        <div className="text-center mb-16" data-id="element-27">
          <div className="inline-flex items-center gap-2 px-4 py-1 rounded-full bg-[#10b981] text-white text-sm font-bold mb-6" data-id="element-28">
            <Gift className="w-4 h-4" data-id="element-29" />
            REGALOS INCLUIDOS
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-30">
            Llevate estos bonus exclusivos gratis
          </h2>
          <p className="text-stone-400 max-w-2xl mx-auto" data-id="element-31">
            Para asegurarnos de que tengas éxito ordenando tus finanzas.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-32">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-stone-800 rounded-2xl border border-stone-700 overflow-hidden" data-id="element-33">
            <div className="relative h-64 overflow-hidden" data-id="element-34">
              <img src="https://cdn.magicpatterns.com/uploads/3kiHBLEGXwKiuAsgNgfX2o/planner.png" alt="Planificador Financiero Imprimible" className="w-full h-full object-cover" data-id="element-35" />
            </div>
            <div className="p-8" data-id="element-36">
              <div className="w-12 h-12 bg-stone-700 rounded-xl flex items-center justify-center mb-6" data-id="element-37">
                <span className="text-2xl font-bold text-[#10b981]" data-id="element-38">1</span>
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-39">
                Planificador Financiero Imprimible
              </h3>
              <p className="text-stone-400" data-id="element-40">
                Ideal si te gusta escribir a mano. Usalo para planificar tu mes,
                organizar prioridades y establecer tus objetivos financieros
                antes de pasarlos a la plantilla.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-stone-800 rounded-2xl border border-stone-700 overflow-hidden" data-id="element-41">
            <div className="relative h-64 overflow-hidden" data-id="element-42">
              <img src="https://cdn.magicpatterns.com/uploads/qepgUjAQtKwuA1emrD4615/tutorial.png" alt="Video Tutorial Paso a Paso" className="w-full h-full object-cover" data-id="element-43" />
            </div>
            <div className="p-8" data-id="element-44">
              <div className="w-12 h-12 bg-stone-700 rounded-xl flex items-center justify-center mb-6" data-id="element-45">
                <span className="text-2xl font-bold text-[#10b981]" data-id="element-46">2</span>
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-47">
                Video Tutorial Paso a Paso
              </h3>
              <p className="text-stone-400" data-id="element-48">
                No necesitás saber usar Excel. Te explico en video y desde cero
                cómo usar cada parte de la plantilla para que le saques el
                máximo provecho.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}